/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Translateddescriptionhtml5Inputs */

const en__field_translateddescriptionhtml5 = /** @type {(inputs: _Field_Translateddescriptionhtml5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description translation`)
};

const de__field_translateddescriptionhtml5 = /** @type {(inputs: _Field_Translateddescriptionhtml5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung Übersetzung`)
};

/**
* | output |
* | --- |
* | "Description translation" |
*
* @param {_Field_Translateddescriptionhtml5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_translateddescriptionhtml5 = /** @type {((inputs?: _Field_Translateddescriptionhtml5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Translateddescriptionhtml5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_translateddescriptionhtml5(inputs)
	return de__field_translateddescriptionhtml5(inputs)
});
export { _field_translateddescriptionhtml5 as "_field_translatedDescriptionHTML" }